import type { NodeDefinition } from '../../../types/node-definition';

/**
 * Knowledge Base Upload Node
 *
 * Adds documents to a knowledge base collection from workflow data.
 * Handles chunking, embedding generation, and index updating.
 * Uses the product-wide OpenAI API key for embeddings.
 *
 * Parameters:
 * - collectionId: The knowledge base collection to upload to
 * - sourceField: Field in input data containing document content
 * - documentName: Name for the uploaded document
 * - chunkSize: Characters per chunk
 * - chunkOverlap: Overlap between chunks
 * - metadata: Optional JSON metadata
 */
export const kbUploadDefinition: NodeDefinition = {
  type: 'kbUpload',
  name: 'KB Upload',
  category: 'utilities',
  description: 'Upload documents to a knowledge base collection from workflow data',
  icon: 'Upload',
  color: 'green',
  version: '1.0.0',

  group: ['ai', 'knowledge-base'],

  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Main',
      required: true
    }
  ],

  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Main'
    }
  ],

  defaults: {
    name: 'KB Upload',
    color: 'green'
  }
};
